import React, { useEffect, useImperativeHandle, forwardRef, useState } from 'react';

import { createPopper } from '@popperjs/core';
import cx from 'classnames';
import './_menu.scss';













// $FlowFixMe
const Menu = forwardRef(({
  children,
  open,
  align,
  id,
  className,
  buttonId,
  fallbackPlacements,
  closeAfterClick,
  toggleCompactMenu
}, ref) => {
  const [menuOpen, setMenuOpen] = useState(open || false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (typeof toggleCompactMenu === 'function') {
      toggleCompactMenu({
        closeMenu: menuOpen
      });
    }
  };

  useImperativeHandle(ref, () => ({
    toggleMenu
  }));

  useEffect(() => {
    const popper = document.getElementById(id);
    const button = document.getElementById(buttonId);

    if (!popper || !button) {
      return;
    }

    const popperInstance = createPopper(button, popper, {
      placement: `bottom-${align || 'start'}`,
      modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10]
        }
      },
      fallbackPlacements ?
      {
        name: 'flip',
        options: {
          fallbackPlacements
        }
      } :
      {}]


    });

    popper.style.opacity = '1';

    // eslint-disable-next-line consistent-return
    return () => {
      popperInstance.destroy();
    };
  }, [menuOpen, align, id, children && Array.isArray(children) && children.length]);

  useEffect(() => {
    const element = document.getElementById(id)?.parentElement;

    if (!element) {
      return;
    }

    const handleMouseDown = (e) => {
      if (!element.contains(e.target)) {
        toggleMenu();
      }
    };

    document.addEventListener('mousedown', handleMouseDown);

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [id, toggleMenu]);

  if (!menuOpen) {
    return null;
  }

  const customClass = className || '';

  const closeMenu = () => {
    if (!closeAfterClick) return;
    setMenuOpen(false);
  };

  return (
    <div
      id={id}
      className={cx('menu', {
        'menu--right-align': align === 'right',
        'menu--padding-bottom': className === 'padding-bottom',
        [customClass]: customClass !== 'padding-bottom'
      })}
      onClick={closeMenu}
      role="button"
      tabIndex={0}
      onKeyDown={closeMenu}
      ref={ref}>

      {children}
    </div>);

});

export default Menu;